import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Mail, ArrowLeft } from 'lucide-react';
import FormInput from '../../components/FormInput';
import * as authApi from '../../api/auth.api';
import { errorMessage } from '../../api/client';
import { BRAND_NAME } from '../../utils/brand';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-card">
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 'var(--s-4)' }}>
        <img src="/fullLogo.png" alt={BRAND_NAME} style={{ height: 48, width: 'auto' }} draggable="false" />
      </div>
      <h2>Reset password</h2>
      <div className="auth-sub">
        Enter your email and we'll send a reset link.
      </div>

      {!sent ? (
        <form onSubmit={onSubmit}>
          <FormInput
            label="Email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
          />
          <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
            <Mail size={16} /> Send reset link
          </button>
        </form>
      ) : (
        <div className="notice">
          If an account exists for <strong>{email}</strong>, a reset link has been sent. Check your inbox.
        </div>
      )}

      <div className="divider" />
      {/* Client 2026-09-10: this email-token reset flow is used by
          clinic / staff / admin / super-admin (Partner Portal). Patients
          use /user-forgot-password (phone OTP). Route back to the
          Partner Portal so the clinic doesn't land on the Member Portal. */}
      <Link to="/portal-login" className="text-sm row" style={{ justifyContent: 'center' }}>
        <ArrowLeft size={14} /> Back to sign in
      </Link>
    </div>
  );
}

export default ForgotPassword;
